export const adminGuestKey = "8990f364226d4fe28c50f762efee6c85";
export const reCapchaKeySite = "6LdzmXQqAAAAAFYD-ktyPZv5W3nNhsriNCOngItb";
export const KeyGroup = "groupKey";
export const KeyUser = "userKey";
